// The contract manager view's routes (not sitemap screens; docs/v3/FEEDBACK-PLAN.md,
// phases 2 and 3). /cm/sign-in and /cm/join/:token use the public shell, the rest the
// CmShell behind a sign-in (routes/coverage.ts shellFor).
import { PAGES } from "@convenor/shared";
import { extra, page, screen, type AreaRoute } from "../../routes/types";
import { demoGated } from "../access/routes";

export const routes: AreaRoute[] = [
  extra(PAGES.cmSignIn, demoGated(page(() => import("./pages/AccessPages"), "CmSignInPage"))),
  extra(PAGES.cmJoin, demoGated(page(() => import("./pages/AccessPages"), "CmJoinPage"))),
  extra(PAGES.cmStart, page(() => import("./pages/AccessPages"), "CmStartPage"), { allowNoOrg: true }),
  // 151: also the team's "Preview as contract manager".
  screen(151, page(() => import("./pages/OverviewPage"), "CmOverviewPage"), { allowNoOrg: true }),
  extra(PAGES.cmTors, page(() => import("./pages/TorPages"), "CmTorQueuePage"), { allowNoOrg: true }),
  extra(PAGES.cmTor, page(() => import("./pages/TorPages"), "CmTorReviewPage"), { allowNoOrg: true }),
  extra(PAGES.cmActivities, page(() => import("./pages/ActivityPages"), "CmActivitiesPage"), { allowNoOrg: true }),
  extra(PAGES.cmActivity, page(() => import("./pages/ActivityPages"), "CmActivityPage"), { allowNoOrg: true }),
  extra(PAGES.cmIndicators, page(() => import("./pages/FigurePages"), "CmIndicatorsPage"), { allowNoOrg: true }),
  extra(PAGES.cmBudget, page(() => import("./pages/FigurePages"), "CmBudgetPage"), { allowNoOrg: true }),
  extra(PAGES.cmMonthly, page(() => import("./pages/MonthlyPage"), "CmMonthlyStartPage"), { allowNoOrg: true }),
  extra(PAGES.cmMonthlyReport, page(() => import("./pages/MonthlyPage"), "CmMonthlyPage"), { allowNoOrg: true }),
  extra(PAGES.cmReports, page(() => import("./pages/FigurePages"), "CmReportsPage"), { allowNoOrg: true }),
  extra(PAGES.cmDocuments, page(() => import("./pages/DocumentsPage"), "CmDocumentsPage"), { allowNoOrg: true }),
];
